import '../assets/NcAppSettingsDialog-x8dImUGK.css';
import Vue, { defineComponent, inject, provide, ref, shallowRef, computed, onBeforeUnmount } from "vue";
import { useVModel, toRef } from "@vueuse/core";
import debounce from "debounce";
import { N as NcDialog } from "./NcDialog-BCCBuI6f.mjs";
import NcVNodes from "../Components/NcVNodes.mjs";
import { u as useLocalizedAppName, A as APP_VERSION } from "./appName-qk1L3dsY.mjs";
import { A as APP_SETTINGS_LEGACY_DESIGN_KEY, a as APP_SETTINGS_REGISTRATION_KEY } from "./useAppSettingsDialog-C73Wx6iQ.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
import { useIsMobile } from "../Composables/useIsMobile.mjs";
import { r as register, M as t49, a as t } from "./_l10n-DVz9Qdzk.mjs";
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "NcAppSettingsDialogVersion",
  setup(__props) {
    const legacy = inject(APP_SETTINGS_LEGACY_DESIGN_KEY);
    const localizedAppName = useLocalizedAppName();
    return { __sfc: true, legacy, localizedAppName, APP_VERSION };
  }
});
const appSettingsDialogVersion = "_appSettingsDialogVersion_ux6wr";
const appSettingsDialogVersion__legacy = "_appSettingsDialogVersion__legacy_xUqjk";
const style0 = {
  "material-design-icon": "_material-design-icon_JnqrJ",
  appSettingsDialogVersion,
  appSettingsDialogVersion__legacy
};
var _sfc_render$1 = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_vm.$style.appSettingsDialogVersion, { [_vm.$style.appSettingsDialogVersion__legacy]: _setup.legacy }] }, [_vm._v(" " + _vm._s(_setup.localizedAppName) + " " + _vm._s(_setup.APP_VERSION) + " ")]);
};
var _sfc_staticRenderFns$1 = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  _sfc_main$1,
  _sfc_render$1,
  _sfc_staticRenderFns$1,
  false,
  _sfc_injectStyles,
  null
);
const NcAppSettingsDialogVersion = __component__$1.exports;
register(t49);
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppSettingsDialog",
  props: {
    open: { type: Boolean },
    showNavigation: { type: Boolean },
    container: { default: "body" },
    name: { default: "" },
    additionalTrapElements: { default: () => [] },
    legacy: { type: Boolean, default: true },
    noVersion: { type: Boolean, default: false }
  },
  emits: ["update:open"],
  setup(__props, { emit }) {
    const props = __props;
    const open = useVModel(props, "open", emit, { passive: true });
    provide(APP_SETTINGS_REGISTRATION_KEY, {
      registerSection,
      unregisterSection
    });
    provide(APP_SETTINGS_LEGACY_DESIGN_KEY, toRef(() => props.legacy));
    const settingsScroller = ref();
    const isMobile = useIsMobile();
    const selectedSection = ref("");
    const linkClicked = ref(false);
    const registeredSections = shallowRef([]);
    const hasNavigation = computed(() => !isMobile.value && props.showNavigation);
    const hasNavigationIcons = computed(() => registeredSections.value.some(({ icon }) => !!icon));
    const unfocusNavigationItem = debounce(() => {
      selectedSection.value = "";
      if (document.activeElement?.className.includes("navigation-list__link")) {
        document.activeElement.blur();
      }
    }, 300);
    const sectionsOrderMap = /* @__PURE__ */ new Map();
    onBeforeUnmount(() => {
      sectionsOrderMap.clear();
    });
    function handleSettingsNavigationClick(item) {
      linkClicked.value = true;
      document.getElementById("settings-section_" + item).scrollIntoView({
        behavior: "smooth",
        inline: "nearest"
      });
      selectedSection.value = item;
      setTimeout(() => {
        linkClicked.value = false;
      }, 1e3);
    }
    function handleCloseModal(isOpen) {
      if (isOpen) {
        return;
      }
      open.value = false;
      settingsScroller.value.scrollTop = 0;
    }
    function handleScroll() {
      if (open.value && !linkClicked.value) {
        unfocusNavigationItem();
      }
    }
    function registerSection(id, name, order, icon) {
      if (registeredSections.value.some(({ id: otherId }) => id === otherId)) {
        throw new Error(`Duplicate section id found: ${id}. Settings navigation sections must have unique section ids.`);
      }
      if (registeredSections.value.some(({ name: otherName }) => name === otherName)) {
        Vue.util.warn(`Duplicate section name found: ${name}. Settings navigation sections must have unique section names.`);
      }
      if (order !== void 0) {
        sectionsOrderMap.set(id, order);
      } else if (sectionsOrderMap.has(id)) {
        order = sectionsOrderMap.get(id);
      } else {
        order = Math.max(0, ...sectionsOrderMap.values()) + 1;
        sectionsOrderMap.set(id, order);
      }
      registeredSections.value = [...registeredSections.value, { id, name, order, icon }].sort(({ order: orderA }, { order: orderB }) => {
        return orderA - orderB;
      });
      if (registeredSections.value.length === 1) {
        selectedSection.value = id;
      }
    }
    function unregisterSection(id) {
      registeredSections.value = registeredSections.value.filter(({ id: otherId }) => id !== otherId);
      if (selectedSection.value === id) {
        selectedSection.value = registeredSections.value[0]?.id ?? "";
      }
    }
    return { __sfc: true, props, emit, open, settingsScroller, isMobile, selectedSection, linkClicked, registeredSections, hasNavigation, hasNavigationIcons, unfocusNavigationItem, sectionsOrderMap, handleSettingsNavigationClick, handleCloseModal, handleScroll, registerSection, unregisterSection, NcDialog, NcVNodes, NcAppSettingsDialogVersion, t };
  }
});
var _sfc_render = function render2() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.open ? _c(_setup.NcDialog, { staticClass: "app-settings", attrs: { "content-classes": ["app-settings__content", { "app-settings__non-legacy": !_vm.legacy }], "navigation-classes": "app-settings__navigation", "additional-trap-elements": _vm.additionalTrapElements, "container": _vm.container, "close-on-click-outside": "", "navigation-aria-label": _setup.t("Settings navigation"), "size": "large", "name": _vm.name }, on: { "update:open": _setup.handleCloseModal }, scopedSlots: _vm._u([_setup.hasNavigation ? { key: "navigation", fn: function({ isCollapsed }) {
    return [!isCollapsed ? _c("ul", { staticClass: "navigation-list" }, _vm._l(_setup.registeredSections, function(section) {
      return _c("li", { key: section.id }, [_c("a", { staticClass: "navigation-list__link", class: {
        "navigation-list__link--active": section.id === _setup.selectedSection,
        "navigation-list__link--icon": _setup.hasNavigationIcons
      }, attrs: { "aria-current": `${section.id === _setup.selectedSection}`, "href": `#settings-section_${section.id}`, "tabindex": "0" }, on: { "click": function($event) {
        $event.preventDefault();
        return _setup.handleSettingsNavigationClick(section.id);
      }, "keydown": function($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _setup.handleSettingsNavigationClick(section.id);
      } } }, [_setup.hasNavigationIcons ? _c("div", { staticClass: "navigation-list__link-icon" }, [section.icon ? _c(_setup.NcVNodes, { attrs: { "vnodes": section.icon } }) : _vm._e()], 1) : _vm._e(), _c("span", { staticClass: "navigation-list__link-text" }, [_vm._v(" " + _vm._s(section.name) + " ")])])]);
    }), 0) : _vm._e()];
  } } : null], null, true) }, [_c("div", { ref: "settingsScroller", on: { "scroll": _setup.handleScroll } }, [_vm._t("default"), !_vm.noVersion ? _c(_setup.NcAppSettingsDialogVersion) : _vm._e()], 2)]) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "31f523ae"
);
const NcAppSettingsDialog = __component__.exports;
export {
  NcAppSettingsDialog as N
};
//# sourceMappingURL=NcAppSettingsDialog-D0M18YFD.mjs.map
